export default defineNuxtPlugin((ctx) => {
    var v = document.createElement("script"), s = document.getElementsByTagName("script")[0];
    v.onload = function() {
        console.log(window)
        window.voiceflow.chat.load({
            verify: { projectID: '65d8add39272d2a4cf635f2a' },
            url: 'https://general-runtime.voiceflow.com',
            versionID: 'production'
        });
    }
    v.src = "https://cdn.voiceflow.com/widget/bundle.mjs"; v.type = "text/javascript"; s.parentNode.insertBefore(v, s);
})